module.exports = __webpack_public_path__ + "media/images/favicon/safari-pinned-tab-ff743ad98e869d2ae4aad43ba387c152.svg";